module.exports = __webpack_public_path__ + "img/10_31.5018637c.png";